import styled, { css } from 'styled-components';
import { getThemeProp } from 'theme';

export const StyledXpackConstraintsSetsTipContent = styled.div`
  width: 226px;
  font-size: 11px;
`;

export const StyledInfoIcon = styled.i.attrs(() => ({
  className: 'icon-tooltip',
}))`
  display: flex;
  font-size: 10.5px;
  color: ${getThemeProp('colors.dustyGrey')};
  margin-left: 5.75px;
`;

// We dont apply styled(Toggler) because there is an issue
// https://github.com/styled-components/styled-components/issues/2271
export const togglerFieldStyles = css`
  && {
    background-color: ${getThemeProp('colors.white')};
    border: 1px solid rgba(144, 151, 168, 0.28);
    border-radius: 3px;
    display: flex;
    height: 36px;
    justify-content: space-around;
    text-align: center;
    width: 100%;
    margin-left: 25.75px;

    &:focus {
      border: 2px solid ${getThemeProp('colors.jordyBlue')};
    }
  }
`;

export const StyledXpackConstraintsLabel = styled.div`
  height: 16px;
  font-size: 13px;
  line-height: 16px;
`;

export const StyledXpackConstraintsContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${getThemeProp('colors.fiordGrey')};
`;

export const StyledLabel = styled.div`
  height: 14px;
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 11px;
  font-weight: 300;
  line-height: 14px;
  margin-bottom: 6px;
`;

export const StyledContainer = styled.div`
  margin: 0 0 32px 14px;
`;
